export type CashOutStripeWalletParams = {
  isInstantPayout?: boolean;
};

export async function cashOutStripeWallet({
  isInstantPayout = false,
}: CashOutStripeWalletParams): Promise<Response> {
  const response = await fetch(`/api/proxy/v3/wallet/cashout`, {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      isInstantPayout,
    }),
  });
  if (response.ok) {
    return response;
  }
  throw new Error('Could not cash out stripe wallet');
}
